import getPlayer from '../../../../Apis/player/getPlayer'

const playerStatsBreadcrumb = async (data) => {
  const { match, pairedOrgId } = data || {}
  const { playerId } = match.params

  // A paired club's selected org is its own, where the federation's player is not: read it under the federation's route.
  const playerName = await getPlayer({ playerId, orgId: pairedOrgId }).then((player) => {
    return `${player?.personalData?.firstName} ${player?.personalData?.lastName}`
  })

  return ['PLAYER STATS', playerName ? playerName.toUpperCase() : '']
}

export default playerStatsBreadcrumb
